String.prototype.toDate = function () {
  const date = new Date(this);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const day = date.getDate().toString().padStart(2, "0");
  return `${day}-${months[date.getMonth()]}-${date.getFullYear()}`;
};

String.prototype.toRemaining = function (inspectionDate) {
  const start = new Date(inspectionDate);
  const end = new Date(this);
  const today = new Date();

  // If already expired
  if (end < today) {
    return "Expired";
  }

  let months =
    (end.getFullYear() - today.getFullYear()) * 12 +
    (end.getMonth() - today.getMonth());

  let days = end.getDate() - today.getDate();

  if (days < 0) {
    months -= 1;
    const prevMonth = new Date(end.getFullYear(), end.getMonth(), 0);
    days += prevMonth.getDate();
  }

  return `${months} months, ${days} days remaining`;
};

String.prototype.toStatus = function () {
  const today = new Date();
  const expiry = new Date(this);

  if (expiry < today) {
    return `
      <span class="text-danger fw-bold">
        Expired <i class="fa fa-times-circle ms-1"></i>
      </span>
    `;
  }

  return `
    <span class="text-success fw-bold">
      Valid <i class="fa fa-check-circle ms-1"></i>
    </span>
  `;
};